module.exports = __webpack_public_path__ + "media/images/icons/outlined/mail-2b5e8b995c0018c9ab1a2f580bf538c4.svg";